export const CREATE_INCENTIVE_SLAB = 'incentive_slab'